import Highcharts from 'highcharts';

export function chartContextButtonInit() {
  if (Highcharts?.SVGRenderer?.prototype) {
    Highcharts.SVGRenderer.prototype.symbols.verticalDots = function(x, y, width, height) {
      const dotRadius = width / 20;
      const dotOffset = width / 10;
      const cx = x + width / 2.3;
      
      return [
          'M', cx, y + dotOffset,
          'a', dotRadius, dotRadius, 0, 1, 0, 0.1, 0,
          'z',
          
          'M', cx, y + width / 2,
          'a', dotRadius, dotRadius, 0, 1, 0, 0.1, 0,
          'z',
          
          'M', cx, y + width - dotOffset,
          'a', dotRadius, dotRadius, 0, 1, 0, 0.1, 0,
          'z'
      ];
    };
  }
}

export const contextButtonVisualSettings = {
  symbol: 'verticalDots',
  x: 9,
  y: -9,
};
